// index.js
import http from "./request";

const getMyBowlerInfo = function () {
  const params = {};
  return http.apiGet("Bowler/GetMyBowlerInfo", params);
};

const getMyMatchSubjectsInfo = function () {
  const params = {};
  return http.apiGet("Bowler/GetMyMatchSubjectsInfo", params);
};

const updateMyBowlerInfo = function (data) {
  return http.apiPost("Bowler/UpdateMyBowlerInfo", data);
};

const MyScore = function (data) {
  return http.apiPost("Bowler/MyScore", data);
};

const MyAccountStatement = function (data) {
  return http.apiPost("Bowler/MyAccountStatement", data);
};

const MyMerchants = function (data) {
  return http.apiPost("Bowler/MyMerchants", data);
};

const GetMyIdCode = function (data) {
  return http.apiPost("Bowler/GetMyIdCode", data);
};

export default {
  getMyBowlerInfo,
  updateMyBowlerInfo,
  getMyMatchSubjectsInfo,
  MyScore,
  MyAccountStatement,
  MyMerchants,
  GetMyIdCode,
};
